/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProviderReferralList } from '../models/PaginatedProviderReferralList';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProviderReferralService {

    /**
     * @returns PaginatedProviderReferralList
     * @throws ApiError
     */
    public static providerReferralList({
        limit,
        offset,
    }: {
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedProviderReferralList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider-referral/',
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
    }

}
